<template>
    <HeadersAuth/>
    <div class="flex justify-center items-center min-h-screen p-12">
        <div class="max-w-[500px] w-full m-auto bg-white px-12 py-10 shadow-[0_4px_38px_rgba(0,0,0,0.12)] rounded-lg">
            <img src="@/assets/logo.png" alt="logo" class="mx-auto mb-12"/>
            <h1 class="font-semibold text-4xl leading-tight text-[#373737] text-center">Reset Password</h1>
            <p class="text-base text-[#575757] pt-4 text-center">Enter details to reset password!</p>
          
            <!-- Forgot Password Section -->
            <span>
                <span>
                    <div class="pt-7">
                        <label class="input-label">Enter OTP <span class="text-red-500">*</span></label>
                        <input class="form-control h-[52px] text-[15px] placeholder:text-[15px]" type="number" placeholder="Please enter otp" v-model="otp"/>
                        <p class="text-red-600" v-if="fieldRequired && otp == ''">OTP is required.</p>
                    </div>
                    <div class="pt-7">
                        <label class="input-label">New Password <span class="text-red-500">*</span></label>
                        <div class="right-icon-input">
                            <input class="form-control h-[52px] text-[15px] placeholder:text-[15px]" :type="hasShow ? 'text' : 'password'" placeholder="Please enter New Password" v-model="newPassword"/>
                            <p class="text-red-600" v-if="fieldRequired && newPassword == ''">New Password is required.</p>
                            <div class="absolute top-3.5 right-4 cursor-pointer" @click="hasShow = !hasShow">
                                <i class="text-[#5F6368] far" :class="hasShow ? 'fa-eye' : 'fa-eye-slash'"></i>
                            </div>
                        </div>
                    </div>
                    <div class="pt-7">
                        <label class="input-label">Confirm Password <span class="text-red-500">*</span></label>
                        <div class="right-icon-input">
                            <input class="form-control h-[52px] text-[15px] placeholder:text-[15px]" :type="hasShow ? 'text' : 'password'" placeholder="Please enter Confirm Password" v-model="confirmPassword"/>
                            <p class="text-red-600" v-if="fieldRequired && confirmPassword == ''">Confirm Password is required.</p>
                            <div class="absolute top-3.5 right-4 cursor-pointer" @click="hasShow = !hasShow">
                                <i class="text-[#5F6368] far" :class="hasShow ? 'fa-eye' : 'fa-eye-slash'"></i>
                            </div>
                        </div>
                    </div>
                    <div class="pt-10">
                        <button type="submit" @click="clickToChangePassword()" :disabled="btnChangePasswordLoader" :class="btnChangePasswordLoader == true ? 'opacity-50 cursor-not-allowed' : ''" class="h-[60px] bg-blue-500 rounded text-lg font-semibold p-3 text-white text-center relative block w-full">
                            Reset Password
                        </button>
                    </div>
                </span>
                <p class="pt-6 text-center">Already registered ? <router-link to="/login" class="text-blue-500 font-medium"> Login</router-link></p>
            </span>

        </div>
    </div>
      <!-- <FooterSection/> -->
</template>
               
<script>
    import HeadersAuth from './HeadersAuth.vue';
    // import FooterSection from './FooterSection.vue';
    import { BASE_URL } from "../../config";
    import axios from "axios";
    import { createToast } from 'mosha-vue-toastify';
    import 'mosha-vue-toastify/dist/style.css';
    import { createLocal } from 'the-storages';

    const mirror = createLocal();
    const storage = mirror._prx;
    export default {
        name: 'LogIn',
        components:{
            HeadersAuth,
            // FooterSection,
        },

        data() {
            return {
                newPassword: '',
                confirmPassword: '',
                checkEmail: this.$route.query.email,
                otp:'',
                btnChangePasswordLoader: false,
                storage: storage,
                fieldRequired: false,
                hasShow: false,
            }
        },

        methods:{

            async clickToChangePassword(){
                if(this.otp === '' || this.newPassword === '' || this.confirmPassword === ''){
                    this.fieldRequired = true;
                    return;
                }
                if(this.newPassword === this.confirmPassword){
                    this.btnChangePasswordLoader = true
                    const formData = {
                                        "email": this.checkEmail,
                                        "otp": this.otp,
                                        "newPassword": this.newPassword,
                                        "confirmPassword": this.confirmPassword,
                                        "ipAddress": this.storage.ipAddress
                                    };

                    console.log(formData);
                    await axios.post(BASE_URL + '/otp-change-password',formData)
                    .then((response)=>{
                        this.fieldRequired = false;
                        this.btnChangePasswordLoader = false;
                        this.tostMessage(response.data.success, response.data.message);  

                        if(response.data.success == 'success'){      
                            this.$router.push({ path: '/login' });                           
                        }
                    })
                    this.btnChangePasswordLoader = false
                } else {
                    this.tostMessage('warning', 'New Password and Confirm Password must be same');
                }                
            },
         
            tostMessage(status,message){
                createToast({
                    // title: title,
                    description: message
                },
                {
                type: status,
                timeout: 2500,
                position: 'bottom-right',
                showIcon: 'true'
                })
            },
        }
    }
</script>